import React from "react";
import PropTypes from "prop-types";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "@mui/material/Button";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import Config from "conFig.js";
import { Error, Success } from "../../../assets/jss/util/messageUtil";

const Capnhatphanloaivantai = React.memo(function Capnhatphanloaivantai(props) {
  const { loaivantai_id } = props;
  const [ten, setTen] = React.useState("");
  const [ma, setMa] = React.useState("");
  const [alert, setAlert] = React.useState(false);
  const [alert1, setAlert1] = React.useState(false);
  const [alertValidate, setAlertValidate] = React.useState(false);
  const [messageValidate, setMessageValidate] = React.useState("");
  const token = localStorage.getItem("token");
  var username = localStorage.getItem("username");
  var obj = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };
  const getloaivantaitheoid = () => {
    var url =
      Config.backend +
      "/api/Phuongtien/getdmplvantaiid?id=" +
      loaivantai_id +
      "&username=" +
      username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        if (data) {
          setTen(data[0].ten);
          if (data[0].ma != null) setMa(data[0].ma);
        }
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const capnhatplvantai = () => {
    let mess = validateCapnhat();
    if (mess === Success.SC0001) {
      var url = Config.backend + "/api/Donvi/capnhatphanloaivantai";
      fetch(url, {
        method: "PUT",
        headers: {
          Accept: "application/json, text/plain",
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          id: loaivantai_id,
          tenloaivantai: ten,
          maloaivantai: ma,
          username: username,
        }),
      })
        .then((res) => res.json())
        .then((data) => {
          if (data === 1) {
            showNotification();
          } else showNotification1();
        })
        .catch((error) => {
          console.error("Error fetching data: ", error);
        });
    } else {
      setMessageValidate(mess);
      showNotificationValidate();
    }
  };
  const showNotificationValidate = () => {
    setAlertValidate(true);
    setTimeout(function () {
      setAlertValidate(false);
    }, 6000);
  };
  const showNotification = () => {
    setAlert(true);
    setTimeout(function () {
      setAlert(false);
    }, 2000);
  };
  const showNotification1 = () => {
    setAlert1(true);
    setTimeout(function () {
      setAlert1(false);
    }, 2000);
  };
  const validateCapnhat = () => {
    // Kiem tra cac truong bat buoc nhap
    if (ten.trim() === "") {
      return Error.ER0017;
    }
    return Success.SC0001;
  };
  React.useEffect(() => {
    getloaivantaitheoid();
  }, []);
  return (
    <div>
      <CardBody style={{ borderBottom: "1px solid #bbb" }}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <FormControl style={{ width: "100%", marginTop: "8px" }}>
              <TextField
                label="Tên loại vận tải"
                variant="outlined"
                size="small"
                value={ten}
                onChange={(event) => {
                  setTen(event.target.value);
                }}
                InputLabelProps={{
                  sx: {
                    color: "red",
                  },
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <FormControl style={{ width: "100%", marginTop: "8px" }}>
              <TextField
                label="Mã loại vận tải"
                variant="outlined"
                size="small"
                value={ma}
                onChange={(event) => {
                  setMa(event.target.value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
        </GridContainer>
      </CardBody>
      <CardFooter style={{ marginBottom: 40 }}>
        <Button
          color="primary"
          variant="contained"
          style={{ height: 27 }}
          onClick={capnhatplvantai}
        >
          Cập nhật
        </Button>
      </CardFooter>
      <GridContainer>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="info"
            icon={AddAlert}
            message="Cập nhật thành công"
            open={alert}
            closeNotification={() => setAlert(false)}
            close
          />
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="warning"
            icon={AddAlert}
            message="Có lỗi trong quá trình cập nhật"
            open={alert1}
            closeNotification={() => setAlert1(false)}
            close
          />
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="warning"
            icon={AddAlert}
            message={messageValidate}
            open={alertValidate}
            closeNotification={() => setAlertValidate(false)}
            close
          />
        </GridItem>
      </GridContainer>
    </div>
  );
});

Capnhatphanloaivantai.propTypes = {
  loaivantai_id: PropTypes.number,
};
export default Capnhatphanloaivantai;
